import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function ActiveConnectionsChart() {
	const connectionData = [
		{ value: 25, name: "EtherNet/IP", color: "#f1bc00" },
		{ value: 20, name: "PROFINET-IO", color: "#26d0ce" },
		{ value: 18, name: "BACnet/IP", color: "#2dccb3" },
		{ value: 15, name: "Modbus-TCP", color: "#3b82f6" },
		{ value: 12, name: "S7COMM", color: "#50cd89" },
		{ value: 10, name: "Other ICS", color: "#e0e0e0" },
	];

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">Active Connections</h5>
					<ReactECharts
						option={{
							tooltip: {
								trigger: "item",
								backgroundColor: "rgba(0, 0, 0, 0.8)",
								borderColor: "#60a5fa",
								textStyle: { color: "#fff" },
								formatter: "{b}: {c}",
							},
							legend: {
								orient: "vertical",
								right: 10,
								top: "center",
								textStyle: { color: "#bfcbdc", fontSize: 12 },
								data: connectionData.map((item) => item.name),
							},
							series: [
								{
									type: "pie",
									center: ["35%", "50%"],
									radius: ["40%", "70%"],
									avoidLabelOverlap: false,
									label: {
										show: false,
										position: "center",
									},
									emphasis: {
										label: {
											show: true,
											fontSize: 14,
											fontWeight: "bold",
										},
									},
									itemStyle: {
										borderRadius: [4, 4, 0, 0],
										borderColor: "#1a1a24",
										borderWidth: 2,
									},
									data: connectionData,
									color: connectionData.map((item) => item.color),
								},
							],
						}}
						style={{
							height: 250,
						}}
						echarts={echarts}
					/>
					<div className="text-white-50 small mt-2">
						Total Active: {connectionData.reduce((sum, item) => sum + item.value, 0)}
					</div>
				</div>
			</div>
		</div>
	);
}
